module.exports = __webpack_public_path__ + "static/890382766.299c32ee.jpg";